import styled from 'styled-components';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    width: 100%;
    padding: 30px 30px 40px;
  `,
    LayoutInputFields: styled.div `
    display: flex;
    flex-direction: column;

    margin-bottom: ${(props) => (props.isLast ? 0 : '30px')};
  `,
    LayoutSpinner: styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
  `,
    LayoutFooter: styled.div `
    display: flex;
    justify-content: center;

    width: 100%;
    margin-top: 40px;
  `,
    GapRow: styled.div `
    width: ${(props) => `${props.width}px`};
  `,
};
